import React from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/Pageheader";
import Sidebar from "../Components/Sidebar";

function Changepassword() {
  return (
    <>
      <Header />
      <PageHeader pagename="change password" />
      {/* Change Password Section  */}
      <section className="profile-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <Sidebar />
            </div>

            <div className="col-md-9">
              <div className="my-info-dv">
                <div className="row">
                  <div className="col-md-6">
                    <div className="my-info-head">
                      <h3 className="primary-color">Change Password</h3>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="edit-profile-dv">
                      <button className="btn-all" style={{ width: "32%" }}>
                        save
                      </button>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="info-border"></div>
                  </div>
                  <div className="col-md-6">
                    <div className="name-info edit-input-info">
                      {/* <label className="primary-color">First Name :</label>  */}
                      <h5 className="primary-color">Current Password</h5>
                      <input type="password" placeholder="Password" />
                      <div className="eye-icon">
                        <i class="fa fa-eye" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="name-info edit-input-info">
                      <h5 className="primary-color">New Password</h5>
                      <input type="password" placeholder="New Password" />
                      <div className="eye-icon">
                        <i class="fa fa-eye" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="name-info edit-input-info">
                      <h5 className="primary-color">Confirm Password</h5>
                      <input type="password" placeholder="Confirm Password" />
                      <div className="eye-icon">
                        <i class="fa fa-eye" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ====================== */}
    </>
  );
}

export default Changepassword;
